var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefreshRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29C22.0751 29 27 24.0751 27 18H29C29 25.1797 23.1797 31 16 31C8.8203 31 3 25.1797 3 18C3 10.8203 8.8203 5 16 5C20.6312 5 24.6967 7.42167 26.9995 11.0678L27 5.99609V5H29V5.99614H29.0001L29 14H27H20.0007H20V12.9982V12H25.2216C23.2578 8.98811 19.8594 7 16 7C9.92487 7 5 11.9249 5 18C5 24.0751 9.92487 29 16 29Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshRight);
export default __webpack_public_path__ + "static/media/refresh-right.e6f4f7f4.svg";
export { ForwardRef as ReactComponent };